export const LOGIN_ROUTE = "/";
export const CHOOSE_DOMAIN_ROUTE = "choose-domain";
